// @flow
import React from "react";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

type Props = {
  onSubmit: (string) => void,
  placeholder: string,
  min: number,
  onMinError?: (number) => void,
  resetOnSubmit?: boolean,
};

type State = {
  query: string,
};

class SearchInput extends React.Component<Props, State> {
  state: State;

  static defaultProps = {
    placeholder: "Search...",
    min: 3,
  };

  constructor(props: Props) {
    super(props);
    this.state = { query: "" };
  }

  handleKeyPress = (e: Event) => {
    if (e.key === "Enter") {
      this.handleSearch();
    }
  };

  handleSearch = () => {
    const { onSubmit, min, onMinError, resetOnSubmit } = this.props;
    const { query } = this.state;
    if (query.length >= min) {
      onSubmit(query);
      resetOnSubmit && this.setState({ query: "" });
    } else {
      onMinError && onMinError(query.length);
    }
  };

  handleTyping = (event: Event) => {
    this.setState({ query: event.target.value });
  };

  render() {
    const { placeholder } = this.props;
    return (
      <FormControl>
        <Input
          value={this.state.query}
          onChange={this.handleTyping}
          onKeyPress={this.handleKeyPress}
          placeholder={placeholder}
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={this.handleSearch}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    );
  }
}

export default SearchInput;
